import {IActionBase} from "./IActionBase";
import {toast} from "react-toastify";
import {Component, Fragment} from "react";
import {ActionsManager} from "./actionsManager";
import {dataUtils} from "../js/dataUtils";
import UI_ApplyooIcon from "../components/componentParts/UI_ApplyooIcon";
import {ToastPosition} from "react-toastify/dist/types";
import { utils_ui } from "../utils/utils_ui";


export class showToastr extends Component implements IActionBase {

    actionCode = "showToastr";
    actionName = "showToastr";

    position:ToastPosition = "bottom-right"


    Execute = (prmActionParameters:any,prmActionsManager:any, prmElementObj?:any)=> {
        const hanleOnClick = () =>{
            if (!!prmActionParameters?.OnClickInfo?.callbackFunction){
                prmActionParameters.OnClickInfo.callbackFunction(prmActionParameters)
            }
        }

        const getToasterTemplate = (prmIcon:any,prmColorHeader:any,prmDefaultHeaderText:any) => {

            return (
                <Fragment>
                    <div className={['toast-wrapper',prmActionParameters.ToastrType].join(" ")}
                    onClick={hanleOnClick}>
                        <div className='toastify-header'>
                            <div className='title-wrapper'>
                                <div className={'title-icon-wrapper'}>
                                    {/* <FontAwesomeIcon size='sm' color={prmColorHeader} icon={utils_ui.parseFontIcon(prmIcon)}/> */}
                                    <UI_ApplyooIcon iconStr={prmIcon} style={{color: prmColorHeader}}/>
                                </div>

                                { prmActionParameters.IsShowHeader ===false
                                    ? null :
                                    <h6 className={['toast-title',`toast-title-override-${prmColorHeader}` ].join(" ")}>
                                        {utils_ui.getLanguageTitle(dataUtils.parseLangKey(prmDefaultHeaderText))}
                                    </h6>  }

                            </div>
                        </div>
                        <div className='toastify-body'>
                              <span role='img' aria-label='toast-text'>
                                {utils_ui.getLanguageTitle(dataUtils.parseLangKey(prmActionParameters?.ToastrMessage))}
                              </span>

                            {
                                //!!prmActionParameters.OnClickInfo && (<></>)
                            }
                        </div>
                    </div>
                </Fragment>
            )
        }

        if(prmActionParameters){
        let currIcon = 'check' ;
        let currColorHeader = 'primary' ;
        let defaultHeaderText = 'Title_ToastrHeader_Success'
        let duration = null
        let isHideProgressBar = true

        if(prmActionParameters.Duration){
            if(prmActionParameters.Duration ===0){
                duration = false
            }
            else{
                duration= prmActionParameters.Duration
            }
        }
        else {
            duration = 3000
        }

        if (prmActionParameters?.ToastrType == "error"){
            //duration = false;
            isHideProgressBar = false
            duration = 7000;
        }

        if(prmActionParameters?.IsShowProgressBar){
            isHideProgressBar = false;
        }

        if(!prmActionParameters.HeaderText){
            prmActionParameters.HeaderText = defaultHeaderText
        }

        switch (prmActionParameters?.ToastrType) {

              case "succeed":
                currIcon = 'check'
                currColorHeader = 'success'
                defaultHeaderText = 'Title_ToastrHeader_Success'

                toast.success(getToasterTemplate(currIcon,currColorHeader,defaultHeaderText), {
                    position: this.position,
                    autoClose: duration,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    hideProgressBar: isHideProgressBar});
                break;

            case "error":
                currIcon = 'times'
                currColorHeader = 'danger'
                defaultHeaderText = 'Title_ToastrHeader_Error'
                toast.error(getToasterTemplate(currIcon,currColorHeader,defaultHeaderText), {
                    position: this.position,
                    autoClose: duration,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    hideProgressBar: isHideProgressBar});
                // });
                break;

            case "info":
                currIcon = 'info'
                currColorHeader = 'info'
                defaultHeaderText = 'Title_ToastrHeader_Info'
                toast.info(getToasterTemplate(currIcon,currColorHeader,defaultHeaderText), {
                    position: this.position,
                    autoClose: duration,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    hideProgressBar: isHideProgressBar});
                break;

            case "warning":
                currIcon = 'exclamation'
                currColorHeader = 'warning'
                defaultHeaderText = 'Title_ToastrHeader_Warning'
                toast.warning(getToasterTemplate(currIcon,currColorHeader,defaultHeaderText), {
                    position: this.position,
                    autoClose: duration,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    hideProgressBar: isHideProgressBar});
                break;

        }


        }


    }

}